import { motion } from "framer-motion";
import { PROFILE_DATA, LINKS_DATA } from "@/lib/index";
import { springPresets, staggerContainer, staggerItem } from "@/lib/motion";
import { ExternalLink } from "lucide-react";

export default function Home() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-background via-background to-secondary/20 flex items-center justify-center p-4">
      <motion.div
        className="w-full max-w-md mx-auto"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={springPresets.gentle}
      >
        <div className="flex flex-col items-center space-y-6">
          <motion.div
            className="relative"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ ...springPresets.bouncy, delay: 0.1 }}
          >
            <div className="w-32 h-32 rounded-full overflow-hidden ring-4 ring-primary/20 shadow-lg">
              <img
                src={PROFILE_DATA.avatar}
                alt={PROFILE_DATA.name}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute inset-0 rounded-full bg-gradient-to-br from-primary/10 to-transparent pointer-events-none" />
          </motion.div>

          <motion.div
            className="text-center space-y-3"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ ...springPresets.gentle, delay: 0.2 }}
          >
            <h1 className="text-3xl font-bold text-foreground tracking-tight">
              {PROFILE_DATA.name}
            </h1>
            <p className="text-sm text-muted-foreground leading-relaxed max-w-sm px-4">
              {PROFILE_DATA.bio}
            </p>
          </motion.div>

          <motion.div
            className="w-full space-y-4 pt-4"
            variants={staggerContainer}
            initial="hidden"
            animate="visible"
          >
            {LINKS_DATA.map((link, index) => (
              <motion.a
                key={index}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full"
                variants={staggerItem}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                transition={springPresets.snappy}
              >
                <div className="relative group">
                  <div className="absolute inset-0 bg-gradient-to-r from-primary/20 to-accent/20 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-200 blur-sm" />
                  <div className="relative bg-card border border-border rounded-xl p-4 shadow-sm hover:shadow-md transition-all duration-200">
                    <div className="flex items-center justify-between">
                      <span className="text-base font-medium text-card-foreground group-hover:text-primary transition-colors duration-200">
                        {link.title}
                      </span>
                      <ExternalLink className="w-5 h-5 text-muted-foreground group-hover:text-primary transition-colors duration-200" />
                    </div>
                  </div>
                </div>
              </motion.a>
            ))}
          </motion.div>

          <motion.footer
            className="pt-8 text-center"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.8 }}
          >
            <p className="text-xs text-muted-foreground">
              © 2026 {PROFILE_DATA.name}
            </p>
          </motion.footer>
        </div>
      </motion.div>
    </div>
  );
}
